import { combineReducers } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import authSlice from "../features/auth/authSlice";
import candidateReducer from "../features/Recruiter/candidateSlice";
import masterDataReducer from "../features/Recruiter/masterDataSlice";
import contractsReducer from "../features/Recruiter/contractSlice";
import recruiterDetailsReducer from "../features/Admin/RecruiterSlice";
import AddUpdateSubscriptionSlice from "../features/Admin/Subscriptions/AddSubscriptionSlice";
import GetLogsEntrys from "../features/Admin/logs/LogsEntrysSlice";
import apiSlice from "../features/Admin/AdminAuthSlice";
import ServicesSlice from "../features/Admin/Services/Services";
import paymentReducer from "../features/Payment/paymentSlice";
import cityReducer from "../features/Recruiter/cityMasterSlice";
import candidateStatusSlice from "../features/Candidate/candidateStatusSlice";
import universityReducer from "../features/Recruiter/universitySlice";
import recruiterDashboardSlice from "../features/Recruiter/Dashboard/recruiterDashboardSlice";
import candidateListSlice from "../features/Recruiter/RecruiterReports/candidateListSlice";
import {  logout } from "../features/auth/authSlice";
import accountReducer from '../features/account/accountSlice';
import ShortListedCandidateApiSlice from '../features/Client/ShortListCandidate';
import productsSlice from '../pages/Recruiter/Enrollment/productsSlice';

const appReducer = combineReducers({
  products:productsSlice,
  auth: authSlice,
  account: accountReducer, 
  candidate: candidateReducer,
  masterData: masterDataReducer,
  recruiterdashboard: recruiterDashboardSlice,
  recruiterDetails: recruiterDetailsReducer,
  city: cityReducer,
  contracts: contractsReducer,
  candidatestatus: candidateStatusSlice,
  payment: paymentReducer,
  university: universityReducer,
  candidatelist: candidateListSlice,
  shortListedCandidates: ShortListedCandidateApiSlice,
  // Admin
  subscription: AddUpdateSubscriptionSlice,
  logEntrys: GetLogsEntrys,
  AdminSlice: apiSlice,
  AdminSlice: apiSlice,
  ServicesDetails: ServicesSlice,
});

const rootReducer = (state, action) => {
  if (action.type === logout.type) {
    state = {
      auth: state.auth,
    };
  }
  return appReducer(state, action);
};

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth"],
};

const persisteReducer = persistReducer(persistConfig, rootReducer);

export default persisteReducer;

// const appReducer = combineReducers({
//   auth: authSlice,
//   // other slices
// });

// const rootReducer = (state, action) => {
//   if (action.type === 'auth/logout') {
//     state = undefined; // Reset the state to initial state
//   }
//   return appReducer(state, action);
// };
